// extracted by mini-css-extract-plugin
export default {"hoverRegion":"zmysqYEyQoZI8ZgqtRoI"};